import { View, type StyleProp, type ViewStyle } from 'react-native';
import { SvgXml } from 'react-native-svg';
import * as flags3x2 from 'country-flag-icons/string/3x2';
import { colors, radii } from '~/ui/tokens';

const FLAGS: Record<string, string> = flags3x2 as unknown as Record<string, string>;

type CountryFlagProps = {
  /** ISO 3166-1 alpha-2 code, any case (this app stores residency/dial codes lowercase). */
  code: string | null | undefined;
  /** Rendered width in px; height follows the flag's native 3:2 ratio. */
  size?: number;
  style?: StyleProp<ViewStyle>;
};

// Small rounded frame + hairline border around every flag — most flags carry
// white or near-white right up to the edge (Japan, Poland, Monaco…), which
// would otherwise bleed invisibly into a white input/dropdown background.
export function CountryFlag({ code, size = 20, style }: CountryFlagProps) {
  const height = Math.round((size * 2) / 3);
  const xml = code ? FLAGS[code.toUpperCase()] : undefined;

  if (!xml) {
    return <View style={[{ width: size, height, borderRadius: 2, backgroundColor: colors.lineSoft }, style]} />;
  }

  return (
    <View style={[{ width: size, height, borderRadius: 2, overflow: 'hidden', borderWidth: 1, borderColor: colors.lineSoft }, style]}>
      <SvgXml xml={xml} width="100%" height="100%" />
    </View>
  );
}
